import { render } from "./inputArea.vue?vue&type=template&id=569f0745&scoped=true"
import script from "./inputArea.vue?vue&type=script&lang=js"
export * from "./inputArea.vue?vue&type=script&lang=js"

import "./inputArea.vue?vue&type=style&index=0&id=569f0745&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-569f0745"]])

export default __exports__